import {observable, action} from 'mobx'
import {api} from 'helpers/Api'
import {ICrudStore} from 'Store'
import {Stock} from './Model'

export default class implements ICrudStore<Stock> {
  @observable stock: Stock[] = []

  read(article?: number): any /* tslint:disable-line:no-any */ {
    if (article)
      return api
        .get(`stock?article=${article}`)
        .then(stock => stock.map(s => new Stock(s)))
    return api.get('stock').then(this.set)
  }

  create(inventory: Stock) {
    return api
      .post('inventory', inventory)
      .then(() => this.read(inventory.article))
  }

  @action
  private set = (stock: Stock[]) => {
    this.stock = stock.map(customer => new Stock(customer))
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Stock/Store.ts